import { loadImage } from "client/utils/imageEdit/loadImage";
import { useEffect } from "react";
import { deleteImage, setDimension, setIsCorrupted, setPreview } from "store/features/bulkResize/actions";
import { BulkResizeImage } from "store/features/bulkResize/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { downloadImageInFrontendTools } from "client/utils/downloadImageInFrontendTools";

export const useBulkResizerPreviewImage = (image: BulkResizeImage) => {
    const unit = useAppSelector((store) => store.bulkResize.resizeSettings.unit);
    const dpi = useAppSelector((store) => store.bulkResize.resizeSettings.dpi);
    const dispatch = useAppDispatch();
    const src = image.preview.src;

    const handleDelete = () => {
        dispatch(deleteImage(image.id));
    };

    const fetchImageDimensions = async () => {
        let src = image.original.src;
        if (
            image.format === ".heic" ||
            image.format === ".heif" ||
            image.format === "heic" ||
            image.format === "heif"
        ) {
            try {
                const blobRes = await fetch(src);
                if (!blobRes) return;
                const blob = await blobRes.blob();
                if (!blob) return;
                const heic2any = (await import("heic2any")).default;
                const conversionRes = await heic2any({ blob });
                src = URL.createObjectURL(Array.isArray(conversionRes) ? conversionRes[0] : conversionRes);
            } catch (error) {}
        }
        const { error, width, height } = await loadImage(src);
        if (error) {
            const { src, error } = await downloadImageInFrontendTools(
                {
                    type: "url",
                    settings: {
                        url: image.original.src,
                    },
                },
                image.original.src,
                0,
            );
            if (error || !src) {
                handleCorruptImage();
                return;
            }
            dispatch(setPreview({ id: image.id, value: { src } }));
            const { width, height } = await loadImage(src);
            if (width === 0 || height === 0) {
                handleCorruptImage();
                return;
            }
            dispatch(
                setDimension({
                    imageId: image.id,
                    width,
                    height,
                }),
            );
            return;
        }

        if (width === 0 || height === 0) {
            handleCorruptImage();
            return;
        }

        dispatch(setPreview({ id: image.id, value: { src } }));

        if (image.original.width === 0 || image.original.height === 0) {
            dispatch(
                setDimension({
                    imageId: image.id,
                    width,
                    height,
                }),
            );
        }
    };

    function handleCorruptImage() {
        console.log(`${image.title} is corrupted`);
        dispatch(
            setIsCorrupted({
                id: image.id,
                isCorrupted: true,
            }),
        );
    }

    useEffect(() => {
        fetchImageDimensions();
    }, [image.original.src]);

    return { handleDelete, unit, dpi, src };
};
